import React from "react";
import { Tabs, Tab } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";

import { onChangeInvoiceTab } from "../../store/slices/preferenceSlice";

import InvoiceSyncRules from "./InvoiceSyncRules";
import InvoiceMappings from "./InvoiceMappings";

const invoiceTabKeys = Object.freeze({
  SyncRules: "syncRules",
  DefaultMappings: "defaultMappings",
  FieldMappings: "fieldMappings",
});

function InvoiceSync() {
  const dispatch = useDispatch();
  const { isInvoiceSyncRulesSaved } = useSelector((state) => state.invoice);

  const {
    invoiceActiveTab,
    status: { loading: setupLoading },
  } = useSelector((state) => state.preference);

  const {
    isMappingSaved: { order: isInvoiceMappingsSaved },
    mapping: {
      defaultMappings: { order: orderMappings },
    },
  } = useSelector((state) => state.mapping);

  return (
    <div className="contact-tabs mt-2">
      <Tabs
        style={{
          top: `${window.location.pathname !== "/setup" && "69px"}`,
        }}
        activeKey={invoiceActiveTab}
        onSelect={(selectedKey) => {
          dispatch(
            onChangeInvoiceTab({
              selectedTab: selectedKey,
              setupLoading,
              isInvoiceSyncRulesSaved,
              isInvoiceMappingsSaved,
              orderMappings,
            })
          );
        }}
      >
        <Tab eventKey={invoiceTabKeys.SyncRules} title="Order/Invoice Sync Rules">
          <InvoiceSyncRules />
        </Tab>
        <Tab
          eventKey={invoiceTabKeys.FieldMappings}
          title="Order/Invoice Field Mappings"
        >
          <InvoiceMappings />
        </Tab>
      </Tabs>
    </div>
  );
}

export default InvoiceSync;
